import { makeStyles, alpha } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  actions: {
    "& > *": {
      marginRight: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
    "& > :last-child": {
      marginRight: 0,
    },
  },
  statusInReview: {
    color: theme.palette.warning.main,
  },
  statusActive: {
    color: theme.palette.success.main,
  },
  statusRejected: {
    color: theme.palette.error.main,
  },
  statusName: {
    textTransform: "uppercase",
  },
  accountHolder: {
    width: "100%",
    textAlign: "center",
    paddingBottom: "1rem",
    [theme.breakpoints.up("sm")]: {
      width: "16rem",
      textAlign: "left",
    },
  },
  accountInfo: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    justifyContent: "space-around",
    [theme.breakpoints.up("sm")]: {
      justifyContent: "right",
    },
  },
  accountStatus: {
    width: "12.75rem",
    borderLeft: "1px solid",
    borderColor: alpha(theme.palette.text.primary, 0.5),
    padding: "0.62rem",
    textAlign: "center",
  },
  accountBank: {
    minWidth: "10rem",
    padding: "10px",
    textAlign: "center",
    wordBreak: "break-all",
    [theme.breakpoints.up("sm")]: {
      width: "12.5rem",
    },
  },
  accountsCard: {
    display: "block",
    [theme.breakpoints.up("sm")]: {
      display: "flex",
    },
  },
  buttonAction: {
    background: theme.palette.change.main,
    "&:hover": {
      background: theme.palette.change.main,
    },
  },
}));

export default useStyles;
